<template>
  <div class="dict-manage">
    <el-card shadow="hover" style="margin-bottom: 20px;">
      <div slot="header" class="clearfix">
        <span style="font-size: 18px; font-weight: 600;">
          <i class="el-icon-collection" style="margin-right: 8px;"></i>
          字典列表
        </span>
        <el-button style="float: right;" type="primary" size="small" @click="handleAdd">
          <i class="el-icon-plus"></i> 新增字典
        </el-button>
      </div>
      
      <!-- 搜索栏 -->
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="字典类型">
          <el-input v-model="searchForm.dictType" placeholder="请输入字典类型" clearable style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="字典名称">
          <el-input v-model="searchForm.dictName" placeholder="请输入字典名称" clearable style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable style="width: 120px;">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadDictList">
            <i class="el-icon-search"></i> 查询
          </el-button>
          <el-button @click="handleReset">
            <i class="el-icon-refresh"></i> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    
    <!-- 字典列表 -->
    <el-card shadow="hover">
      <el-table
        :data="dictList"
        border
        stripe
        style="width: 100%"
        v-loading="loading">
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="dictType" label="字典类型" width="180"></el-table-column>
        <el-table-column prop="dictName" label="字典名称" width="150"></el-table-column>
        <el-table-column prop="description" label="描述" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
        <el-table-column label="操作" width="280" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleViewItems(scope.row)">
              <i class="el-icon-view"></i> 字典项
            </el-button>
            <el-button size="mini" @click="handleEdit(scope.row)">
              <i class="el-icon-edit"></i> 编辑
            </el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
              <i class="el-icon-delete"></i> 删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.current"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>
    
    <!-- 新增/编辑字典对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false">
      <el-form :model="dictForm" :rules="dictRules" ref="dictForm" label-width="100px">
        <el-form-item label="字典类型" prop="dictType">
          <el-input v-model="dictForm.dictType" placeholder="请输入字典类型（如：sys_status）" :disabled="!!dictForm.id"></el-input>
        </el-form-item>
        <el-form-item label="字典名称" prop="dictName">
          <el-input v-model="dictForm.dictName" placeholder="请输入字典名称"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="dictForm.description" type="textarea" :rows="3" placeholder="请输入描述"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="dictForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
      </div>
    </el-dialog>
    
    <!-- 字典项管理对话框 -->
    <el-dialog
      title="字典项管理"
      :visible.sync="itemDialogVisible"
      width="900px"
      :close-on-click-modal="false">
      <div style="margin-bottom: 15px;">
        <el-button type="primary" size="small" @click="handleAddItem">
          <i class="el-icon-plus"></i> 新增字典项
        </el-button>
      </div>
      
      <el-table
        :data="dictItemList"
        border
        stripe
        style="width: 100%">
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="itemLabel" label="字典标签" width="150"></el-table-column>
        <el-table-column prop="itemValue" label="字典值" width="150"></el-table-column>
        <el-table-column prop="sort" label="排序" width="80" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEditItem(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDeleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    
    <!-- 新增/编辑字典项对话框 -->
    <el-dialog
      :title="itemFormTitle"
      :visible.sync="itemFormVisible"
      width="500px"
      append-to-body
      :close-on-click-modal="false">
      <el-form :model="itemForm" :rules="itemRules" ref="itemForm" label-width="100px">
        <el-form-item label="字典标签" prop="itemLabel">
          <el-input v-model="itemForm.itemLabel" placeholder="请输入字典标签"></el-input>
        </el-form-item>
        <el-form-item label="字典值" prop="itemValue">
          <el-input v-model="itemForm.itemValue" placeholder="请输入字典值"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="itemForm.sort" :min="0" :max="9999" style="width: 100%;"></el-input-number>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="itemForm.remark" type="textarea" :rows="2" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="itemForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="itemFormVisible = false">取消</el-button>
        <el-button type="primary" @click="handleItemSubmit" :loading="itemSubmitting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DictManage',
  data() {
    return {
      loading: false,
      submitting: false,
      itemSubmitting: false,
      searchForm: {
        dictType: '',
        dictName: '',
        status: null
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      dictList: [],
      dialogVisible: false,
      dialogTitle: '新增字典',
      dictForm: {
        id: null,
        dictType: '',
        dictName: '',
        description: '',
        status: 1
      },
      dictRules: {
        dictType: [
          { required: true, message: '请输入字典类型', trigger: 'blur' }
        ],
        dictName: [
          { required: true, message: '请输入字典名称', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      },
      itemDialogVisible: false,
      currentDict: null,
      dictItemList: [],
      itemFormVisible: false,
      itemFormTitle: '新增字典项',
      itemForm: {
        id: null,
        dictId: null,
        itemLabel: '',
        itemValue: '',
        sort: 0,
        remark: '',
        status: 1
      },
      itemRules: {
        itemLabel: [
          { required: true, message: '请输入字典标签', trigger: 'blur' }
        ],
        itemValue: [
          { required: true, message: '请输入字典值', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.loadDictList()
  },
  methods: {
    // 加载字典列表
    async loadDictList() {
      this.loading = true
      try {
        const params = {
          current: this.pagination.current,
          size: this.pagination.size,
          ...this.searchForm
        }
        const res = await this.$axios.get('/admin/dict/list', { params })
        if (res.data.code === 200) {
          this.dictList = res.data.data.records || []
          this.pagination.total = res.data.data.total || 0
        } else {
          this.$message.error(res.data.message || '加载字典列表失败')
        }
      } catch (error) {
        console.error('加载字典列表失败:', error)
        this.$message.error('加载字典列表失败')
      } finally {
        this.loading = false
      }
    },
    
    // 重置搜索
    handleReset() {
      this.searchForm = {
        dictType: '',
        dictName: '',
        status: null
      }
      this.pagination.current = 1
      this.loadDictList()
    },
    
    // 新增字典
    handleAdd() {
      this.dialogTitle = '新增字典'
      this.dictForm = {
        id: null,
        dictType: '',
        dictName: '',
        description: '',
        status: 1
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.dictForm && this.$refs.dictForm.clearValidate()
      })
    },
    
    // 编辑字典
    handleEdit(row) {
      this.dialogTitle = '编辑字典'
      this.dictForm = { ...row }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.dictForm && this.$refs.dictForm.clearValidate()
      })
    },
    
    // 提交字典表单
    handleSubmit() {
      this.$refs.dictForm.validate(async (valid) => {
        if (!valid) return
        
        this.submitting = true
        try {
          const url = this.dictForm.id ? '/admin/dict/update' : '/admin/dict/add'
          const res = await this.$axios.post(url, this.dictForm)
          if (res.data.code === 200) {
            this.$message.success(this.dictForm.id ? '修改成功' : '新增成功')
            this.dialogVisible = false
            this.loadDictList()
          } else {
            this.$message.error(res.data.message || '操作失败')
          }
        } catch (error) {
          console.error('提交失败:', error)
          this.$message.error('操作失败')
        } finally {
          this.submitting = false
        }
      })
    },
    
    // 删除字典
    handleDelete(row) {
      this.$confirm('确定要删除该字典吗？删除后字典项也将被删除。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await this.$axios.delete(`/admin/dict/delete/${row.id}`)
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            this.loadDictList()
          } else {
            this.$message.error(res.data.message || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    
    // 查看字典项
    async handleViewItems(row) {
      this.currentDict = row
      this.itemDialogVisible = true
      await this.loadDictItems(row.id)
    },
    
    // 加载字典项列表
    async loadDictItems(dictId) {
      try {
        const res = await this.$axios.get(`/admin/dict/items/${dictId}`)
        if (res.data.code === 200) {
          this.dictItemList = res.data.data || []
        } else {
          this.$message.error(res.data.message || '加载字典项失败')
        }
      } catch (error) {
        console.error('加载字典项失败:', error)
        this.$message.error('加载字典项失败')
      }
    },
    
    // 新增字典项
    handleAddItem() {
      this.itemFormTitle = '新增字典项'
      this.itemForm = {
        id: null,
        dictId: this.currentDict.id,
        itemLabel: '',
        itemValue: '',
        sort: 0,
        remark: '',
        status: 1
      }
      this.itemFormVisible = true
      this.$nextTick(() => {
        this.$refs.itemForm && this.$refs.itemForm.clearValidate()
      })
    },
    
    // 编辑字典项
    handleEditItem(row) {
      this.itemFormTitle = '编辑字典项'
      this.itemForm = { ...row }
      this.itemFormVisible = true
      this.$nextTick(() => {
        this.$refs.itemForm && this.$refs.itemForm.clearValidate()
      })
    },
    
    // 提交字典项表单
    handleItemSubmit() {
      this.$refs.itemForm.validate(async (valid) => {
        if (!valid) return
        
        this.itemSubmitting = true
        try {
          const url = this.itemForm.id ? '/admin/dict/item/update' : '/admin/dict/item/add'
          const res = await this.$axios.post(url, this.itemForm)
          if (res.data.code === 200) {
            this.$message.success(this.itemForm.id ? '修改成功' : '新增成功')
            this.itemFormVisible = false
            await this.loadDictItems(this.currentDict.id)
          } else {
            this.$message.error(res.data.message || '操作失败')
          }
        } catch (error) {
          console.error('提交失败:', error)
          this.$message.error('操作失败')
        } finally {
          this.itemSubmitting = false
        }
      })
    },
    
    // 删除字典项
    handleDeleteItem(row) {
      this.$confirm('确定要删除该字典项吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await this.$axios.delete(`/admin/dict/item/delete/${row.id}`)
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            await this.loadDictItems(this.currentDict.id)
          } else {
            this.$message.error(res.data.message || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    
    // 分页
    handleSizeChange(val) {
      this.pagination.size = val
      this.pagination.current = 1
      this.loadDictList()
    },
    
    handleCurrentChange(val) {
      this.pagination.current = val
      this.loadDictList()
    }
  }
}
</script>

<style scoped>
.dict-manage {
  padding: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>
